// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EduColumn_wrapper__3U4en","removeBtn":"EduColumn_removeBtn__26uwG"};